import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { requestPasswordReset, confirmPasswordReset } from '../api/auth';
import { CenteredLayout } from '../components/PageLayout';
import Card from '../components/Card';
import Input from '../components/Input';
import Button from '../components/Button';
import Alert from '../components/Alert';

export default function PasswordResetPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [form, setForm] = useState({ password:'', password_confirm:'' });
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleRequest = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await requestPasswordReset(email);
      setMsg(data.detail);
    } catch { setError('发送失败，请重试'); } finally { setLoading(false); }
  };

  const handleConfirm = async (e) => {
    e.preventDefault();
    if (form.password !== form.password_confirm) { setError('两次密码不一致'); return; }
    setError(''); setLoading(true);
    try {
      const { data } = await confirmPasswordReset(token, form.password, form.password_confirm);
      setMsg(data.detail);
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      setError(err.response?.data?.detail || '重置失败，链接可能已过期');
    } finally { setLoading(false); }
  };

  return (
    <CenteredLayout>
      <div style={{textAlign:'center',marginBottom:32}}>
        <Link to="/" style={{fontWeight:800,fontSize:24,color:'var(--color-primary)'}}>AIQ 测评</Link>
        <h1 style={{fontSize:22,fontWeight:700,marginTop:16,marginBottom:4}}>{token?'设置新密码':'找回密码'}</h1>
      </div>
      <Card>
        {msg && <Alert type="success">{msg}</Alert>}
        {error && <Alert type="error">{error}</Alert>}
        {token ? (
          <form onSubmit={handleConfirm}>
            <Input label="新密码" type="password" value={form.password} required onChange={e=>setForm({...form,password:e.target.value})} placeholder="至少8位"/>
            <Input label="确认密码" type="password" value={form.password_confirm} required onChange={e=>setForm({...form,password_confirm:e.target.value})} placeholder="再次输入新密码"/>
            <Button type="submit" fullWidth loading={loading}>设置新密码</Button>
          </form>
        ) : (
          <form onSubmit={handleRequest}>
            <Input label="注册邮箱" type="email" value={email} required onChange={e=>setEmail(e.target.value)} placeholder="your@email.com"/>
            <Button type="submit" fullWidth loading={loading}>发送重置链接</Button>
          </form>
        )}
      </Card>
      <p style={{textAlign:'center',marginTop:20,fontSize:14,color:'var(--color-text-secondary)'}}>
        <Link to="/login" style={{color:'var(--color-secondary)'}}>← 返回登录</Link>
      </p>
    </CenteredLayout>
  );
}
